export default class AclChecker {

    constructor(abilities = [], restrictions = []) {

        this.abilities = [];
        this.restrictions = [];

        this.setAbilities(abilities);
        this.setRestrictions(restrictions);
    }

    can(ability, entity = null, id = null) {
        return this.isAllowed(ability, entity, id) && !this.isForbidden(ability, entity, id)
    }

    isAllowed(ability, entity = null, id = null) {
        return this.exists(this.abilities, ability, entity, id);
    }

    isForbidden(ability, entity = null, id = null) {
        return this.exists(this.restrictions, ability, entity, id);
    }

    setAbilities(abilities) {
        this.abilities = this.parseAbilities(abilities);
        return this;
    }

    setRestrictions(restrictions) {
        this.restrictions = this.parseAbilities(restrictions);
        return this;
    }

    parseAbilities(abilities) {
        return abilities.map(item => {
            return {
                ability: item.name,
                entity: this.parseEntity(item.entity_type),
                id: item.entity_id ? parseInt(item.entity_id) : null
            };
        });
    }

    parseEntity(entity = null) {

        if (!_.isString(entity)) {
            return null;
        }

        if (entity === '*') {
            return entity;
        }

        return entity.substring(entity.lastIndexOf("\\") + 1);
    }

    exists(abilities, ability, entity = null, id = null) {
        let found = abilities.filter(item => {

            let check = true;

            if (id) {
                check &= item.id === null || item.id === parseInt(id);
            } else {
                check &= item.id === null;
            }

            if (entity) {
                check &= item.entity === entity || item.entity === '*';
            } else {
                check &= item.entity === null || item.entity === '*';
            }

            check &= item.ability === ability || item.ability === '*';

            return check;
        });

        return !!found.length;
    }
}
